import { render, staticRenderFns } from "./TrackingInsight.vue?vue&type=template&id=67b447af&scoped=true"
import script from "./TrackingInsight.vue?vue&type=script&lang=js"
export * from "./TrackingInsight.vue?vue&type=script&lang=js"
import style0 from "./TrackingInsight.vue?vue&type=style&index=0&id=67b447af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b447af",
  null
  
)

export default component.exports